import {
  noop
} from "./chunk-7FNX7RWY.mjs";

// src/utils/createDeferredPromise.ts
var createDeferredPromise = () => {
  let resolve = noop;
  let reject = noop;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
};

export {
  createDeferredPromise
};
//# sourceMappingURL=chunk-7QJ2QTJL.mjs.map